import React, { useState, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import debounce from "lodash/debounce";
import { track, eventCategories, analyticsEvents } from "util/analytics";
import styles from "./styles.module.scss";

const TypeAhead = ({ predictableItems, searchKey, onItemClick }) => {
  const ref = useRef();
  const [searchTerm, setSearchTerm] = useState("");
  const filteredPredictableItems = predictableItems.filter((item) =>
    item[searchKey].toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())
  );

  const onSearchTermChange = (term) => setSearchTerm(term);
  const trackAnalytics = (term) =>
    track(analyticsEvents.search, {
      label: term,
      category: eventCategories.location_selector,
    });
  const emitDebounce = useCallback(
    (term) => debounce(onSearchTermChange, 300)(term),
    []
  );
  const emitAnalytics = useCallback(
    (term) => debounce(trackAnalytics, 2000)(term),
    []
  );
  const selectItem = (item) => {
    onItemClick(item);
    setSearchTerm("");
    ref.current.value = "";
  };

  return (
    <>
      <input
        type="text"
        name="search"
        onChange={(e) => {
          e.persist();
          emitDebounce(e.target.value);
          if (e.target.value.length >= 5) emitAnalytics(e.target.value);
        }}
        placeholder="Search for a neighborhood"
        className={styles.searchBar}
        ref={ref}
      />
      {searchTerm.trim() !== "" && (
        <ul className={styles.items}>
          {filteredPredictableItems.map((item) => (
            <li key={item[searchKey]}>
              <div
                role="button"
                className={styles.item}
                tabIndex={0}
                onClick={() => {
                  selectItem(item);
                }}
                onKeyPress={({ key }) => {
                  if (key === "Enter") selectItem(item);
                }}
              >
                {item[searchKey]}
              </div>
            </li>
          ))}
          {filteredPredictableItems.length === 0 && (
            <li className={styles.item}>No results found.</li>
          )}
        </ul>
      )}
    </>
  );
};

TypeAhead.propTypes = {
  predictableItems: PropTypes.arrayOf(PropTypes.shape({})),
  onItemClick: PropTypes.func,
  searchKey: PropTypes.string,
};
TypeAhead.defaultProps = {
  predictableItems: [],
  onItemClick: () => {},
  searchKey: "name",
};

export default TypeAhead;
